import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography from "@insite/mobius/Typography";
import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS, TYPOGRAPHY } from "@tCentro/theme/design";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    heading = "heading",
    subHeading = "subHeading",
    videoUrl = "videoUrl",
    videoCaption = "videoCaption",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.heading]: string;
        [fields.subHeading]: string;
        [fields.videoUrl]: string;
        [fields.videoCaption]: string;
    };
}

export interface LeadTemplateVideoStyles {
    cardWrapper?: InjectableCss;
    videoHeading?: InjectableCss;
    videoSubHeading?: InjectableCss;
    videoCaption?: InjectableCss;
    dashedSeperator?: InjectableCss;
    mobileVideo?: InjectableCss;
}

export const leadTemplateVideoStyles: LeadTemplateVideoStyles = {
    cardWrapper: {
        css: css`
            margin-bottom: 56px;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        margin-bottom: 45px;
                    `,
                    null,
                ]);
            }}
        `,
    },
    videoHeading: {
        css: css`
            margin-bottom: 16px !important;
            ${({ theme }) => {
                return breakpointMediaQueries(theme, [
                    css`
                        text-align: left;
                        font-size: ${TYPOGRAPHY.size.largest};
                    `,
                    null,
                ]);
            }}
        `,
    },
    videoSubHeading: {
        css: css`
            margin-bottom: 56px !important;
            line-height: 28px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    videoCaption: {
        css: css`
            font-weight: ${TYPOGRAPHY.weight.base};
            font-size: ${TYPOGRAPHY.size.smaller};
            line-height: 20px;
            color: ${getProp("theme.typography.p.color")};
        `,
    },
    mobileVideo: {
        css: css`
            @media (min-width: 992px) and (max-width: 1199px) {
                iframe {
                    width: 500px;
                    height: 275px;
                }
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        iframe {
                            width: 343px;
                            height: 193.22px;
                        }
                    `,
                    css`
                        iframe {
                            width: 553px;
                            height: 313.22px;
                        }
                    `,
                    css``,
                    css``,
                    css``,
                ])}
        `,
    },
};

const styles = leadTemplateVideoStyles;
export const LeadTemplateVideo: FC<OwnProps> = ({ fields }) => {
    return (
        <StyledWrapper className="video-wrapper" {...styles.cardWrapper}>
            <StyledWrapper>
                <Typography variant="h4" {...styles.videoHeading}>
                    {translate("{0}", fields.heading)}
                </Typography>
                <Typography variant="p" {...styles.videoSubHeading}>
                    {translate("{0}", fields.subHeading)}
                </Typography>
            </StyledWrapper>
            <StyledWrapper {...styles.mobileVideo}>
                <iframe width="650px" height="365px" src={fields.videoUrl} frameBorder="0"></iframe>
                <br />
            </StyledWrapper>

            <Typography {...styles.videoCaption}>{translate("{0}", fields.videoCaption)}</Typography>
        </StyledWrapper>
    );
};

const leadTemplateVideo: WidgetModule = {
    component: LeadTemplateVideo,
    definition: {
        group: "Basic",
        icon: "image-landscape",
        fieldDefinitions: [
            {
                fieldType: "Translatable",
                name: fields.heading,
                editorTemplate: "TextField",
                displayName: "Heading",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.subHeading,
                editorTemplate: "TextField",
                displayName: "Sub heading",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.videoUrl,
                editorTemplate: "TextField",
                displayName: "Video Link",
                defaultValue: "",
            },
            {
                fieldType: "Translatable",
                name: fields.videoCaption,
                editorTemplate: "TextField",
                displayName: "Video Caption",
                defaultValue: "",
            },
        ],
    },
};

export default leadTemplateVideo;
